import React from "react";
import "./StationInformation.css";
import GameWindowHeader from "../GameWindowHeader";
import GameWindowBg from "../GameWindowBg";
import GameTabViewUI from "../Tabs/GameTabViewUI";
import GameData from "../../../gameplay/model/GameData";
import GameButtonWithIcon from "../GameButtonWithIcon";
import info_icon from "../../../images/gameplay_ui/icons/info_icon.svg";
import {CLIENT_NAMES} from "../../../constants/Constants";
import GameButtonWithText from "../GameButtonWithText";
import TrainCarPackCard from "../LocoCards/TrainCarPackCard";
import LocoPopupCard from "../LocoCards/LocoPopupCard";
import {CLIENT_COLORS, STATION_HEADER_COLORS} from "../GameStyleUI";
import CurrencyCard from "../GeneralCards/CurrencyCard";

import loco_brigade_icon from "../../../images/gameplay_ui/icons/loco_brigade_icon.svg"
import brigade_icon from "../../../images/gameplay_ui/icons/brigades_icon.svg"
import car_train_icon from "../../../images/gameplay_ui/icons/car_train_icon.svg";
import brigade_chips_icon from "../../../images/gameplay_ui/icons/brigade_chips_icon.svg";
import GameController from "../../../gameplay/controllers/GameController";
import {IsPackOther} from "../../../gameplay/model/Balance";

export default class StationInformation extends React.Component {
  constructor() {
    super();

    this.state = {
      currentStation: 0
    }
  }

  componentDidMount() {
    this.setState({
      currentStation: this.props.station.id
    })
  }

  onSelectStation(id) {
    this.setState({
      currentStation: id
    })
  }

  getCargoScroll() {
    let scrollStyle = {
      paddingTop: "20px",
      display: "flex",
      width: "1415px",
      height: "157px",
      overflowX: "visible",
      overflowY: "hidden"
    }
    let substitutes = {width: "150px", height: "150px"};

    let station = GameData.CurrentGame.stations[this.state.currentStation];
    let trainPacks = station.trainCarsPacks;
    let trainPacksCards = [];
    for (let i = 0; i < trainPacks.length; i++) {
      trainPacksCards.push(<div className="card-bg" key={i}><TrainCarPackCard trainCarsPack={trainPacks[i]}/>
      </div>);
    }

    if (!trainPacksCards.length) {
      for (let i = 0; i < 5; i++) {
        trainPacksCards.push(<div key={i} className="card-bg" style={substitutes}/>)
      }
    }

    return <div style={scrollStyle}>
      {trainPacksCards}
    </div>
  }

  getLocoScroll() {
    let scrollStyle = {
      display: "flex",
      width: "1415px",
      height: "157px",
      overflowX: "visible",
      overflowY: "hidden"
    }
    let substitutes = {width: "100px", height: "149px"};

    let station = GameData.CurrentGame.stations[this.state.currentStation];
    let locos = GameData.CurrentGame.getStationLocomotives(station.id);
    let locoCards = [];
    for (let i = 0; i < locos.length; i++) {
      locoCards.push(<div key={i} className={"card-bg"}><LocoPopupCard loco={locos[i]}
                                                                       style={{paddingRight: "10px"}}/>
      </div>);
    }

    if (!locoCards.length) {
      for (let i = 0; i < 5; i++) {
        locoCards.push(<div key={i} className="card-bg" style={substitutes}/>)
      }
    }

    return <div style={scrollStyle}>
      {locoCards}
    </div>
  }

  render() {
    let station = GameData.CurrentGame.stations[this.state.currentStation];


    // Считаем количество вагонов на станции
    let trainCarsCount = 0;

    // УТРОМ все вагоны на погрузку хранятся в переменной orderTrainCarPacks
    // Потом, ДНЕМ на сервере они обнуляются и добавляются новые объекты в массив trainCarPacks
    // Значит, УТРОМ и ДНЕМ должны быть разные формулы подсчета вагонов, т.к. эта информация хранится в разных массивах

    if (GameData.CurrentGame.state === 2) { // Если УТРО
      // Нужно брать данные из текущей сортировки
      for (let i = 0; i < station.orderTrainPacks.length; i++) {
        let pack = GameData.CurrentGame.getOrderTrainCarById(station.orderTrainPacks[i]);
        trainCarsCount += pack.trainCarCount;
      }
    } // ДНЕМ каждый orderTrainCarPacks.trainCarCount стал равен 0, а в trainCarPacks запушились эти вагоны


    let places = Object.keys(station.clientPlaces).map((el, i) => {
      let clientName = CLIENT_NAMES[el];

      let count = 0;

      station.trainCarsPacks.forEach(train => {
        let pack = GameData.CurrentGame.getTrainCarById(train);
        let trainClient = pack.client;
        if ((trainClient === clientName || trainClient === el || (el === "other" && IsPackOther(pack.type))) && pack.isPreparing)
          count++;
      });

      station.orderTrainPacks.forEach(train => {
        let pack = GameData.CurrentGame.getOrderTrainCarById(train);

        if ((pack.client === clientName || pack.client === el || (el === "other" && IsPackOther(pack.type))))
          count += Math.ceil(pack.trainCarCount / 20);
      });

      let title = `${clientName || "Прочее"} (${count}/${station.clientPlaces[el] + GameData.CurrentGame.getRentedPlaces(station.id, el)})`;

      return <GameButtonWithText style={i !== Object.keys(station.clientPlaces).length && {marginRight: "10px"}}
                                 width={270} height={30} key={i} title={title}
                                 isHideEvents={true}
                                 colorStart={CLIENT_COLORS[el]}
                                 colorEnd={CLIENT_COLORS[el]}/>
    });

    let textStyle = {
      marginTop: 40,
      marginBottom: 10,
      fontSize: 14,
      fontWeight: "bold",
      textAlign: "left",
      textTransform: "uppercase"
    }

    let content = <div className="station-information__body" style={{textAlign: "left", padding: "40px 10px"}}>
      <GameTabViewUI width={1416} selectedIndex={this.state.currentStation}
                     selectedStyles={STATION_HEADER_COLORS[this.state.currentStation]}
                     onSelectedIndex={this.onSelectStation.bind(this)}
                     tabs={GameData.CurrentGame.stations.map(el => el.name)}/>

      <div style={textStyle}>локомотивы на станции</div>

      <div className="locos-container">
        {this.getLocoScroll()}
      </div>

      <div style={textStyle}>место на станции</div>

      <div className="places-container">
        {places}
      </div>

      <div className="cargo-container">
        {this.getCargoScroll()}
      </div>

      <div className="buttons" style={{marginTop: "40px"}}>
        <GameButtonWithIcon
          icon={info_icon}
          width={208}
          height={40}
          fontSize={14}
          iconSize={20}
          marginText={10}
          title={"грузоподъёмность"}
          onClick={() => {
            this.props.openDictionaryAt("t-places");
          }}
          style={{marginRight: "20px"}}
        />
        <GameButtonWithIcon
          icon={info_icon}
          width={276}
          height={40}
          fontSize={14}
          iconSize={20}
          marginText={10}
          title={"индекс удовлетворённости"}
          onClick={() => {
            this.props.openDictionaryAt("t-iuk");
          }}
          style={{marginRight: "20px"}}
        />
        <GameButtonWithIcon
          icon={info_icon}
          width={164}
          height={40}
          fontSize={14}
          iconSize={20}
          marginText={10}
          title={"индекс опыта"}
          onClick={() => {
            this.props.openDictionaryAt("t-ino");
          }}
        />
      </div>
    </div>

    let currencyBlocks = [<CurrencyCard
      key={'cur-1'}
      title={"Количество вагонов"}
      icon={car_train_icon}
      value={station.trainCars - trainCarsCount}
      size={20}
      fontSize={14}
      style={{
        marginLeft: "10px"
      }}
    />, <CurrencyCard
      key={'cur-2'}
      title={"Локомотивные бригады"}
      icon={loco_brigade_icon}
      value={GameController.calculateAvailableLocoBrigades(station)}
      size={20}
      fontSize={14}
      style={{
        marginLeft: "10px"
      }}
    />, <CurrencyCard
      key={'cur-3'}
      title={"Станционные бригады"}
      icon={brigade_icon}
      value={station.brigades + GameData.CurrentGame.getRentedBrigades("station", station.id)}
      size={20}
      fontSize={14}
      style={{
        marginLeft: "10px"
      }}
    />, <CurrencyCard
      key={'cur-4'}
      title={"Трудозатраты"}
      icon={brigade_chips_icon}
      value={GameController.calculateAvailableStationBrigadesChips(station)}
      size={20}
      fontSize={14}
      style={{
        marginLeft: "10px"
      }}
    />,];

    return <div className="station-information container__shadow">
      <div className="station-information__content container__content">
        <GameWindowHeader width={1436} height={40}
                          title={"Информация о станции"} onHide={this.props.onHide} isClosable={true}
                          currencyBlocks={currencyBlocks}/>
        <GameWindowBg color={"#FFFFFF"} width={1436} height={690} value={content}/>
      </div>
    </div>
  }
}
